// GENERATED by scripts/gen-design-tokens.mjs from design/tokens.json. Do not edit by hand.
import type { ThemeTokens } from '../tokens'

/** Signal, light: the product's light theme. */
export const signalLight: ThemeTokens = {
  'accent-primary': '#0b6fd1',
  'accent-primary-hover': '#0a58a8',
  'accent-secondary': '#3d8fe0',
  'font-family': "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', sans-serif",
  'font-family-mono': "'IBM Plex Mono', ui-monospace, 'Cascadia Mono', Menlo, Consolas, monospace",
  'font-size-xs': '0.75rem',
  'font-size-sm': '0.8125rem',
  'font-size-base': '0.875rem',
  'font-size-md': '1rem',
  'font-size-lg': '1.125rem',
  'font-size-xl': '1.25rem',
  'font-size-2xl': '1.5rem',
  'font-weight-normal': '400',
  'font-weight-medium': '500',
  'font-weight-semibold': '600',
  'font-weight-bold': '600',
  'line-height': '1.5',
  'spacing-xs': '0.25rem',
  'spacing-sm': '0.5rem',
  'spacing-md': '1rem',
  'spacing-lg': '1.5rem',
  'spacing-xl': '2rem',
  'spacing-2xl': '3rem',
  'bg-primary': '#f6f8fa',
  'bg-secondary': '#ffffff',
  'content-bg': '#f6f8fa',
  'text-primary': '#0b0e13',
  'text-secondary': '#4a5565',
  'text-muted': '#5f6b7a',
  'link-color': '#0b6fd1',
  'link-hover': '#0a58a8',
  'border-color': '#e3e8ee',
  'border-strong': '#cdd5df',
  'header-height': '52px',
  'header-bg': '#ffffff',
  'header-text': '#0b0e13',
  'header-text-muted': '#5f6b7a',
  'header-hover-bg': '#f1f4f7',
  'sidebar-width': '232px',
  'sidebar-collapsed-width': '56px',
  'sidebar-bg': '#f6f8fa',
  'sidebar-text': '#4a5565',
  'sidebar-text-hover': '#0b0e13',
  'sidebar-hover-bg': '#edf1f5',
  'sidebar-active-bg': '#ffffff',
  'sidebar-active-text': '#0b0e13',
  'card-bg': '#ffffff',
  'card-border': '#e3e8ee',
  'card-header-bg': '#f9fafb',
  'table-border': '#edf1f5',
  'table-header-bg': '#f9fafb',
  'table-header-text': '#4a5565',
  'table-header-hover-bg': '#f1f4f7',
  'table-row-hover': '#f6f8fa',
  'table-row-selected': '#e8f2fd',
  'btn-primary-bg': '#0b6fd1',
  'btn-primary-text': '#ffffff',
  'btn-primary-hover': '#0a58a8',
  'btn-secondary-bg': '#ffffff',
  'btn-secondary-text': '#0b0e13',
  'btn-secondary-border': '#cdd5df',
  'btn-secondary-hover': '#f1f4f7',
  'btn-danger-bg': '#c9353a',
  'btn-danger-text': '#ffffff',
  'btn-danger-hover': '#b02c31',
  'input-bg': '#ffffff',
  'input-text': '#0b0e13',
  'input-border': '#cdd5df',
  'input-placeholder': '#8a94a3',
  'input-focus-border': '#0b6fd1',
  'input-focus-ring': 'rgba(11, 111, 209, 0.18)',
  'status-success': '#1a8f55',
  'status-success-bg': 'rgba(26, 143, 85, 0.10)',
  'status-danger': '#c9353a',
  'status-danger-bg': 'rgba(201, 53, 58, 0.10)',
  'status-warning': '#b7791f',
  'status-warning-bg': 'rgba(183, 121, 31, 0.12)',
  'status-info': '#0b6fd1',
  'status-info-bg': 'rgba(11, 111, 209, 0.10)',
  'shadow-sm': '0 1px 2px rgba(11, 14, 19, 0.05)',
  'shadow-md': '0 4px 10px rgba(11, 14, 19, 0.06)',
  'shadow-lg': '0 12px 24px rgba(11, 14, 19, 0.08)',
  'shadow-xl': '0 24px 48px rgba(11, 14, 19, 0.12)',
  'radius-sm': '5px',
  'radius-md': '8px',
  'radius-lg': '10px',
  'radius-full': '9999px',
  'transition-fast': '0.12s ease-out',
  'transition-normal': '0.16s ease-out',
  'transition-slow': '0.24s ease-out',
  'z-dropdown': '100',
  'z-sidebar': '200',
  'z-header': '300',
  'z-modal': '400',
  'z-toast': '500',
  'z-tooltip': '600',
  'hover-bg': '#f1f4f7',
  'modal-overlay': 'rgba(11, 14, 19, 0.45)',
  'tooltip-bg': '#0b0e13',
  'tooltip-text': '#f6f8fa',
  'skeleton-base': '#e3e8ee',
  'skeleton-highlight': '#f1f4f7',
  'terminal-bg': '#fafbfc',
  'terminal-fg': '#24292f',
  'terminal-cursor': '#0b6fd1',
  'terminal-ansi-black': '#24292f',
  'terminal-ansi-red': '#cf222e',
  'terminal-ansi-green': '#116329',
  'terminal-ansi-yellow': '#8a6a00',
  'terminal-ansi-blue': '#0969da',
  'terminal-ansi-magenta': '#8250df',
  'terminal-ansi-cyan': '#1b7c83',
  'terminal-ansi-white': '#6e7781',
  'viewer-bg': '#000000',
  'chart-series-1': '#0b6fd1',
  'chart-series-2': '#1a8f55',
  'chart-series-3': '#b7791f',
  'chart-series-4': '#c9353a',
  'chart-series-5': '#7c3aed',
  'chart-series-6': '#0891b2',
  'chart-series-7': '#db2777',
  'chart-series-8': '#c2410c',
  'chart-warning-fg': '#000000',
  'chart-critical-fg': '#ffffff',
  'ring-label-fg': '#000000',
}
